import {
  Table,
  TableBody,
  TableCell,
  TableRow,
  Typography,
} from '@mui/material';
import Iconify from 'src/components/iconify';
import { OptionPreview } from './OptionPreview/index.tsx';
import { DeleteDialog } from './DeleteDialog';
import { useState } from 'react';
import { OptionType, QuestionType } from '@/@types/api.types.ts';

interface OptionsTableProps {
  options: OptionType[];
  lang: string;
  question: QuestionType;
  editOptionHandler: (index: number) => void;
  deleteOptionHandler: (index: number) => void;
}

export const OptionsTable = ({
  deleteOptionHandler,
  editOptionHandler,
  lang,
  options,
  question,
}: OptionsTableProps) => {
  const [openConfirm, setOpenConfirm] = useState(false);
  const [optionId, setOptionId] = useState<number>(0);

  return (
    <>
      {options.length === 0 ? (
        <Typography gutterBottom>No options</Typography>
      ) : (
        <Table sx={{ minWidth: 650 }} aria-label='simple table'>
          <TableBody>
            {options.map((option, index) => (
              <TableRow
                key={index}
                sx={{
                  '&:last-child td, &:last-child th': { border: 0 },
                }}
              >
                <TableCell component='th' scope='row'>
                  <OptionPreview
                    option={option}
                    lang={lang}
                    question={question}
                    matchStats={undefined}
                    form={undefined}
                  />
                </TableCell>
                <TableCell align='right'>
                  <Iconify
                    icon='eva:edit-2-outline'
                    onClick={() => editOptionHandler(index)}
                    sx={{ cursor: 'pointer', margin: 3 }}
                  />
                  <Iconify
                    icon='eva:trash-2-outline'
                    onClick={() => {
                      setOpenConfirm(true);
                      setOptionId(option.option_id);
                    }}
                    sx={{ cursor: 'pointer', margin: 3 }}
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      )}

      <DeleteDialog
        openConfirm={openConfirm}
        setOpenConfirm={setOpenConfirm}
        id={optionId}
        deleteHandler={deleteOptionHandler}
        type={'option'}
      />
    </>
  );
};
